import moment from 'moment';

export const getAccountCurrency = (setting = {}) => {
    const currency = setting?.regionalSettings?.currency;
    
    if (currency) {
        let symbol = '';
        if(currency && currency.includes('-')) {
            symbol = currency.split('-');    
        } else {
            symbol = currency.split(' ');
        }
        return symbol[1];
    } else {
        return '$';
    }
}

export const dateOnlyFormatted = (setting, date) => {
    if(!date)
        return '';

    const dateFormat = setting?.regionalSettings?.dateFormat ? setting?.regionalSettings?.dateFormat.replace(/dd/g, 'DD').replace(/yy/g, 'YY').replace(/mm/g, 'MM') : 'YY-MM-DD';
    return moment(date).format(`${dateFormat}`);
}

export const utcToLocalDateString = (setting, date) => {
    if(!date)
        return '';

    const dateFormat = setting?.regionalSettings?.dateFormat ? setting?.regionalSettings?.dateFormat.replace(/dd/g, 'DD').replace(/yy/g, 'YY').replace(/mm/g, 'MM') : 'YY-MM-DD';
    return moment.utc(date).local().format(`${dateFormat}`);
}

export const utcToLocalDateTimeString = (setting, date) => {
    if(!date)
        return '';

    const dateFormat = setting?.regionalSettings?.dateFormat ? setting?.regionalSettings?.dateFormat.replace(/dd/g, 'DD').replace(/yy/g, 'YY').replace(/mm/g, 'MM') : 'YY-MM-DD';
    const timeFormat = setting?.regionalSettings?.timeFormat ? (setting?.regionalSettings?.timeFormat.trim().toLowerCase() === "hh:mm a" ? "hh:mm a" : "HH:mm"): "HH:mm";

    return moment.utc(date).local().format(`${dateFormat} ${timeFormat}`);
}

export const utcToLocalTimeString = (setting, date) => {
    if(!date)
        return '';

    const timeFormat = setting?.regionalSettings?.timeFormat ? (setting?.regionalSettings?.timeFormat.trim().toLowerCase() === "hh:mm a" ? "hh:mm a" : "HH:mm"): "HH:mm";

    return moment.utc(date).local().format(`${timeFormat}`);
}

export const isValidDate = (date) => {
    return date instanceof Date && !isNaN(date);
  }

export const localDateToISODateString = (date) => {
    if(!isValidDate(date))
        return null;

    return moment(date).format("YYYY-MM-DD");
}


export const localDateFormatted = (setting, date) => {
    if(!isValidDate(date))
        return null;

    const dateFormat = setting?.regionalSettings?.dateFormat ? setting?.regionalSettings?.dateFormat.replace(/dd/g, 'DD').replace(/yy/g, 'YY').replace(/mm/g, 'MM') : 'YY-MM-DD';

    return moment(date).format(dateFormat);
}

export const localDateTimeFormatted = (setting, date) => {
    if(!isValidDate(date))
        return null;

    const dateFormat = setting?.regionalSettings?.dateFormat ? setting?.regionalSettings?.dateFormat.replace(/dd/g, 'DD').replace(/yy/g, 'YY').replace(/mm/g, 'MM') : 'YY-MM-DD';
    const timeFormat = setting?.regionalSettings?.timeFormat ? (setting?.regionalSettings?.timeFormat.trim().toLowerCase() === "hh:mm a" ? "hh:mm a" : "HH:mm"): "HH:mm";

    return moment(date).format(`${dateFormat} ${timeFormat}`);
}

export const localTimeFormatted = (setting, date) => {
    if(!isValidDate(date))
        return null;

    const timeFormat = setting?.regionalSettings?.timeFormat ? (setting?.regionalSettings?.timeFormat.trim().toLowerCase() === "hh:mm a" ? "hh:mm a" : "HH:mm"): "HH:mm";

    return moment(date).format(`${timeFormat}`);
}

export const displayDecimalFormatted = (setting = {}, value) => {
    let groupingSeparator = setting?.regionalSettings?.groupSeparator ?? ',',
    decimalSeparator = setting?.regionalSettings?.decimalSeparator ?? '.';
    
    const formattedNumber = parseFloat(value).toLocaleString(undefined, {
        maximumFractionDigits: 2,
        useGrouping: true,
    });

    const groupFormatted = formattedNumber.replace(/,/g, groupingSeparator);
    const finalFormatted = groupFormatted.replace(/\./g, decimalSeparator);
    return finalFormatted || '';
}

export const weeksBetweenDates = (startDateUtc, endDateUtc) => {
    if(!startDateUtc || !endDateUtc)
        return '';

    const start = moment.utc(startDateUtc);
    const end = moment.utc(endDateUtc);

    const diffInDays = end.diff(start, 'days', true);

    if (diffInDays < 7) {
    return `${Math.round(diffInDays)} days`;
    } else {
    const weeks = diffInDays / 7;
    return `${weeks.toFixed(1)} weeks`;
    }
};

export const isDateGreaterThan = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
  
    const startOnlyDate = new Date(start.setHours(0, 0, 0, 0));
    const completionOnlyDate = new Date(end.setHours(0, 0, 0, 0));
  
    return startOnlyDate > completionOnlyDate;
}

export const dateFormats = [
    "YYYY-MM-DD",
    "YY-MM-DD",
    "YYYY/MM/DD",
    "YY/MM/DD",
    "DD/MM/YYYY",
    "DD/MM/YY",
    "DD MMM YYYY",
    "DD, MMM YYYY",
    "DD MMM, YYYY",
    "DD-MMM-YYYY",
    "DD MMMM YYYY",
  ];